const trad = {
  namespaced: true,
  state: {
    trad: {
      es: {
        // global
        app: {
          activar: "Activar",
          cerrar: "Cerrar",
          cancelar: "Cancelar",
          diadia: "día a día",
          instalar: "Agregar a inicio",
          legal: "Legal",
          misericordia: "Misericordia",
          nosotros: "Sobre nosotros",
          ora: "Ora",
          salir: "Salir",
          siguiente: "Siguiente",
          terminar: "Terminar"
        },
        dias: {
          0: "Domingo",
          1: "Lunes",
          2: "Martes",
          3: "Miércoles",
          4: "Jueves",
          5: "Viernes",
          6: "Sábado",
          allDays: "Todos los días",
          hoy: "Hoy",
          ayer: "Ayer"
        },
        meses: {
          1: "Enero",
          2: "Febrero",
          3: "Marzo",
          4: "Abril",
          5: "Mayo",
          6: "Junio",
          7: "Julio",
          8: "Agosto",
          9: "Septiembre",
          10: "Octubre",
          11: "Noviembre",
          12: "Diciembre"
        },
        idiomas: {
          en: "Inglés",
          es: "Español",
          fr: "Frances",
          pt: "Portugés"
        },
        validacion: {
          noVacio: "No debe estar vacio.",
          superaMax: "Supera el máximo permitido."
        },
        // components
        mdd: {
          escribe: "Escribe",
          idioma: "Idioma",
          leer: "Leer",
          oracionManiana: "Oración de la mañana",
          oracionNoche: "Oración de la noche",
          lecturasDia: "Lecturas del día",
          paso: "Paso",
          profundiza: "Profundiza",
          versionLit: "Versión de la Liturgia",
          msgProxDias: "...En los próximos días podrás usarlas.",
          msgMostSanto: "Mostrar santo antes de las lecturas",
          msgMostCompr: "Mostrar compromiso del día",
          recordatorios: "Recordatorios",
          tamanio: "Tamaño",
          tamEvang: "Mateo 28, 8-15",
          tamText:
            "En aquel tiempo, las mujeres se marcharon a toda prisa del sepulcro; impresionadas y llenas de alegría, corrieron a anunciarlo a los discípulos. De pronto, Jesús les salió al encuentro y les dijo: “Alégrense.”"
        },
        cuaderno: {
          aprendeComo: "Aprende cómo!",
          color: "Color",
          mostrarEn: "Mostrar en el cuaderno",
          tuOraDia: "Tú oración del día",
          resumMes: "Resumen mensual",
          ambos: "Ambos",
          deOracion: "Cuaderno de Oración",
          escribeAquiComp: "Escribe aquí tu compromiso del día.",
          escribeAquiOra: "Escribe aquí tu oración personal.",
          escribeOra: "Escribe tu oración personal",
          hazComprom: "Haz un compromiso cada día",
          hoyNoComp: "Hoy no hiciste un compromiso.",
          vdlm: "Voz de la Misericordia",
          tuOraPerson: "Tu oración personal",
          tuComprom: "Tu compromiso",
          tuCompromHoy: "Tu compromiso de hoy",
          msgDiaIncompleto:
            '<span class="font-weight-bold">Bienvenido a tu cuaderno<br />de oración personal.</span><br />Aquí podrás ver la Voz de la Misericordia, tu respuesta a esa Palabra y tu compromiso para cada día.',
          msgEscribeOra:
            "La oración es un diálogo, te animamos a escribir todos los días una respuesta personal a tu Padre Dios, hazlo con confianza y sencillez.",
          msgHazComprom:
            "Por último, se dócil a Dios que te habla, cada día puedes hacer un pequeño propósito y confía que el Señor llevará a buen término la obra que ha comenzado en ti.",
          msgPodrasVerTxts:
            "En este espacio podrás ver los textos bíblicos que subrayas en el paso anterior.",
          msgVoz:
            "Cuando hagas tu oración personal recuerda seleccionar el pasaje de la Palabra de Dios que más llamó tu atención, este será la Voz de la Misericordia para ese día."
        },
        lecturas: {
          biblicas: "Lecturas Bíblicas",
          colorLiturgia: "Color liturgia",
          msgTutor1: "Para subrayar un texto, manten tu dedo",
          msgTutor2:
            "sobre la pantalla sin moverlo por unos segundos. Esto activará la herramienta de selección de tu dispositivo.",
          msgTutor3: "Cuando hayas elegido el texto, presiona el botón:",
          msgTutor4: "Si quieres borrar un subrayado, usa el botón",
          msgTutor5: "y presiona encima del texto."
        },
        config: {
          opcionesUsuario: "Opciones de usuario",
          miPerfil: "Mi perfil",
          libroMdd: "Libro MDD",
          portadaMdd: "Portada MDD",
          tamLetra: "Tamaño letra",
          ubicacion: "Ubicación"
        },
        auth: {
          datosUsuario: "Datos de usuario",
          nombre: "Nombre",
          userInvitado: "Usuario invitado",
          pendienteAct: "Pendiente activar",
          datosPlan: "Datos de Plan Activo",
          tipo: "Tipo",
          estado: "Estado",
          activada: "Activada",
          caduca: "Caduca"
        },
        licen: {
          activa: "Activo",
          tipoGratuita: "Invitado",
          inactiva: "Inactiva"
        },
        perfil: {
          fNac: "Fecha de nacimiento",
          sexo: "Sexo",
          hombre: "Hombre",
          mujer: "Mujer",
          orden: "Orden",
          opcional: "Opcional"
        },
        orden: [
          { cod: "o", name: "Obispo" },
          { cod: "s", name: "Sacerdote" },
          { cod: "r", name: "Religiosa(o)" },
          { cod: "l", name: "Laico" }
        ],
        ubic: {
          pais: "País",
          depto: "Depto o Estado",
          ciudad: "Ciudad",
          eligePais: "Elige un país"
        }
      },
      pt: {
        // global
        app: {
          activar: "Ativar",
          cerrar: "Fechar",
          cancelar: "Cancelar",
          diadia: "dia a dia",
          instalar: "Adicionar à tela",
          legal: "Legal (es)",
          misericordia: "Misericórdia",
          nosotros: "Sobre nós",
          ora: "Orar",
          salir: "Sair",
          siguiente: "Seguinte",
          terminar: "Concluir"
        },
        dias: {
          0: "Domingo",
          1: "Segunda-feira",
          2: "Terça-feira",
          3: "Quarta-feira",
          4: "Quinta-feira",
          5: "Sexta-feira",
          6: "Sabado",
          allDays: "Todos os dias",
          hoy: "Hoje",
          ayer: "Ontem"
        },
        meses: {
          1: "Janeiro",
          2: "Fevereiro",
          3: "Março",
          4: "Abril",
          5: "Maio",
          6: "Junho",
          7: "Julho",
          8: "August",
          9: "Setembro",
          10: "Outubro",
          11: "Novembro",
          12: "Dezembro"
        },
        idiomas: {
          en: "Inglês",
          es: "Espanhol",
          fr: "Frances",
          pt: "Português"
        },
        validacion: {
          noVacio: "Não deve estar vazio..",
          superaMax: "Excede o máximo permitido."
        },
        // components
        mdd: {
          escribe: "Escreve",
          idioma: "Linguagem",
          leer: "Ler",
          oracionManiana: "Oração da manhã",
          oracionNoche: "Oração da noite",
          lecturasDia: "Leituras do dia",
          paso: "Passo",
          profundiza: "Aprofundar",
          versionLit: "Versão litúrgica",
          msgProxDias: "...Nos próximos dias você pode usá-los.",
          msgMostSanto: "Mostrar santo antes das leituras",
          msgMostCompr: "Mostrar engajamento do dia",
          recordatorios: "Lembretes",
          tamanio: "Tamanho",
          tamEvang: "João 15,9-17",
          tamText:
            "Naquele tempo, disse Jesus a seus discípulos: Como meu Pai me amou, assim também eu vos amei. Permanecei no meu amor."
        },
        cuaderno: {
          aprendeComo: "Aprenda como!",
          color: "Cor",
          mostrarEn: "Mostrar no caderno",
          tuOraDia: "Sua oração do dia",
          resumMes: "Resumo mensal",
          ambos: "Ambos",
          deOracion: "Caderno de oração",
          escribeAquiComp: "Escreva aqui seu compromisso para o dia.",
          escribeAquiOra: "Escreva sua oração pessoal aqui.",
          escribeOra: "Escreva sua oração pessoal",
          hazComprom: "Faça um compromisso de cada dia",
          hoyNoComp: "Você não fez um compromisso hoje.",
          vdlm: "Voz da Misericórdia",
          tuOraPerson: "Sua oração pessoal",
          tuComprom: "Seu compromisso",
          tuCompromHoy: "Seu compromisso por hoje",
          msgDiaIncompleto:
            '<span class = "font-weight-bold"> Bem-vindo ao seu<br />caderno de oração pessoal. </span> <br /> Aqui você verá a Voz da Misericórdia, sua resposta a essa Palavra e seu compromisso de cada dia.',
          msgEscribeOra:
            "A oração é um diálogo, nós encorajamos você a escrever uma resposta pessoal ao seu Deus Pai todos os dias, fazê-lo com confiança e simplicidade.",
          msgHazComprom:
            "Por fim, seja dócil a Deus que fala com você, todos os dias você pode fazer um pequeno propósito e confiar que o Senhor trará frutos a obra que começou em você",
          msgPodrasVerTxts:
            "Neste espaço, você verá os textos bíblicos sublinhados na etapa anterior.",
          msgVoz:
            "Quando você fizer sua oração pessoal, lembre-se de selecionar a passagem da Palavra de Deus que mais chamou sua atenção, esta será a Voz da Misericórdia para esse dia."
        },
        lecturas: {
          biblicas: "Leituras Bíblicas",
          colorLiturgia: "Cor da liturgia",
          msgTutor1: "Para sublinhar um texto, mantenha seu dedo",
          msgTutor2:
            "na tela sem movê-lo por alguns segundos. Isso ativará a ferramenta de seleção do seu dispositivo.",
          msgTutor3: "Quando você escolher o texto, pressione o botão:",
          msgTutor4: "Se você deseja excluir um sublinhado, use o botão",
          msgTutor5: "e clique no texto."
        },
        config: {
          opcionesUsuario: "Opções do usuário",
          miPerfil: "Meu perfil",
          libroMdd: "Livro MDD",
          portadaMdd: "Cover MDD",
          tamLetra: "Tamanho da letra",
          ubicacion: "Localização"
        },
        auth: {
          datosUsuario: "Dados do usuário",
          nombre: "Nome",
          userInvitado: "Usuário convidado",
          pendienteAct: "Pendente para ativar",
          datosPlan: "Dados ativos do plano",
          tipo: "Tipo",
          estado: "Estado",
          activada: "Ativado",
          caduca: "Expira"
        },
        licen: {
          activa: "Ativo",
          tipoGratuita: "Convidado",
          inactiva: "Inativo"
        },
        perfil: {
          fNac: "Data de nascimento",
          sexo: "Sexo",
          hombre: "Homem",
          mujer: "Mulher",
          orden: "Ordem",
          opcional: "Opcional"
        },
        orden: [
          { cod: "o", name: "Bispo" },
          { cod: "s", name: "Padre" },
          { cod: "r", name: "Religiosa(o)" },
          { cod: "l", name: "Leigo/a" }
        ],
        ubic: {
          pais: "País",
          depto: "Estado",
          ciudad: "Cidade",
          eligePais: "Acompanhar um paíss"
        }
      }
    }
  },
  getters: {
    activa(state, getters, rootState, rootGetters) {
      let config = rootGetters["user/config"];
      let lng = config.mdd.lng || "es";
      return state.trad[lng];
    }
  }
};

export default trad;
